/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FeatureServiceBinder,
  FeatureServiceProviderDefinition,
  SharedFeatureService,
} from '@feature-hub/core';

let data: any[] = []; // In-memory storage for productQuote data
export interface SharedDataJson {
  getData: () => any[];
  setData: (newData: any) => void;
}
export interface SharedData extends SharedFeatureService {
  readonly '1.0.0': FeatureServiceBinder<SharedDataJson>;
}
export const sharedDataServiceDefinition: FeatureServiceProviderDefinition<SharedData> = {
  id: 'api:get-shared-data',
  create: () => ({
    '1.0.0': (): any => {
      return {
        featureService: {
          getData: (): any[] => {
            return data; // Return in-memory data
          },
          setData: (newData: any): void => {
            if (newData !== null && newData !== undefined) {
              data = { ...data, ...newData }; // Update in-memory storage
            }
          },
        },
      };
    },
  }),
};
